<script>
export default {
  mounted() {
    window.location.href = 'https://slack.com/oauth/v2/authorize?client_id=4988886068833.4999957200144&redirect_uri=https://app.chatspell.co/login&response_type=code&scope=users%3Aread%20users%3Aread.email%20incoming-webhook%20channels%3Amanage%20channels%3Ahistory%20channels%3Ajoin%20chat%3Awrite%20commands';
  }
}
</script>
